import { createAsyncThunk } from '@reduxjs/toolkit';
import Geocode from 'react-geocode';
import { GEO_API } from '../../Apis/Constants';

Geocode.setApiKey(GEO_API);

/**
 * @Email : jfragoso@ibl.mx
 * @Author: Jhovanny Fragoso Marquez
 * @jobTittle: Frontend Developer
 *
 * Async thunk that retrieves a formatted address for given latitude and longitude, index
 * using the Google Geocode API.
 *
 * @async
 * @function GetAddressFromLatLng
 * @param {Object} params - Parameters object: { lat: lat, lng: lng, location: index }
 * @param {number|string} lat - The latitude coordinate.
 * @param {number|string} lng - The longitude coordinate.
 * @param {number} location - index of list: The API returns a list of 8 address formats. To get the desired address, you need to provide the corresponding index. By default, it returns the address at index 0 of the list
 * @returns {Promise<{location: string, trans: string, success: boolean, message: string }>}
 *
 * @example
 * dispatch(GetAddressFromLatLng({ lat: lat, lng: lng, location: 3 }));
 */

const createResponse = (location, trans, success, message) => ({
    location,
    trans,
    success,
    message,
});

export const GetAddressFromLatLng = createAsyncThunk(
    'addressSection/getAddressFromLatLng',
    async ({ lat, lng, location = 1 }, { rejectWithValue }) => {
        try {
            const response = await Geocode.fromLatLng(lat, lng);
            if (response?.results?.length > 0) {
                return createResponse(response.results[location].formatted_address, "the_address_was_found_successfully", true, response?.status);
            }
            return createResponse(null, "address_not_found", false, response?.message || response?.status);
        } catch (error) {
            const message = error?.message;
            if(message.includes("INVALID_REQUEST")){
                return rejectWithValue(
                    createResponse(null, "the_request_is_malformed", false, message)
                );
            }
            return rejectWithValue(
                createResponse(null, "provided_coordinates_are_invalid", false, message)
            );
        }
    }
);
